export const setParkingBookings = (state, response) => {
  state.parkingBookings = response
}
export const setParkingBooking = (state, response) => {
  state.parkingBooking = response[0]
}
